/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['آدھی رات', 'صبح', 'دوپہر', 'سہ پہر', 'شام', 'رات'], ,
    [
      'آدھی رات', 'صبح میں', 'دوپہر میں', 'سہ پہر', 'شام میں',
      'رات میں'
    ]
  ],
  [
    ['آدھی رات', 'صبح', 'دوپہر', 'سہ پہر', 'شام', 'رات'],
    ,
  ],
  [
    '00:00', ['04:00', '12:00'], ['12:00', '16:00'], ['16:00', '18:00'], ['18:00', '20:00'],
    ['20:00', '04:00']
  ]
];
